import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { LottoWalletItem } from './models/lotto-wallet-item.model';

export interface LottoWalletState extends EntityState<LottoWalletItem> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'lotto-wallet', idKey: 'LottoId', cache: { ttl: 20000 } })
export class LottoWalletStore extends EntityStore<LottoWalletState> {
  constructor() {
    super();
  }
}
